export const LOAD_FINANCED_OFFERS_STARTED = "LOAD_FINANCED_OFFERS_STARTED";
export const LOAD_FINANCED_OFFERS_SUCCEEDED = "LOAD_FINANCED_OFFERS_SUCCEEDED";
export const LOAD_FINANCED_OFFERS_FAILED = "LOAD_FINANCED_OFFERS_FAILED";

export const LOAD_FOLDER_OFFER_PARTNERS_STARTED = "LOAD_FOLDER_OFFER_PARTNERS_STARTED";
export const LOAD_FOLDER_OFFER_PARTNERS_SUCCEEDED = "LOAD_FOLDER_OFFER_PARTNERS_SUCCEEDED";
export const LOAD_FOLDER_OFFER_PARTNERS_FAILED = "LOAD_FOLDER_OFFER_PARTNERS_FAILED";

export const LOAD_CLIENT_OFFERS_STARTED = "LOAD_CLIENT_OFFERS_STARTED";
export const LOAD_CLIENT_OFFERS_SUCCEEDED = "LOAD_CLIENT_OFFERS_SUCCEEDED";
export const LOAD_CLIENT_OFFERS_FAILED = "LOAD_CLIENT_OFFERS_FAILED";

export const SAVE_FOLDER_FINANCED_OFFERS_FAILED = "SAVE_FOLDER_FINANCED_OFFERS_FAILED";
export const SAVE_FOLDER_FINANCED_OFFERS_SUCCEEDED = "SAVE_FOLDER_FINANCED_OFFERS_SUCCEEDED";
export const SAVE_FOLDER_FINANCED_OFFERS_STARTED = "SAVE_FOLDER_FINANCED_OFFERS_STARTED";

export const BLOCK_FACILITY_SUBLIMIT_AMOUNT_MANUALLY_STARTED = "BLOCK_FACILITY_SUBLIMIT_AMOUNT_MANUALLY_STARTED";
export const BLOCK_FACILITY_SUBLIMIT_AMOUNT_MANUALLY_SUCCEEDED = "BLOCK_FACILITY_SUBLIMIT_AMOUNT_MANUALLY_SUCCEEDED";
export const BLOCK_FACILITY_SUBLIMIT_AMOUNT_MANUALLY_FAILED = "BLOCK_FACILITY_SUBLIMIT_AMOUNT_MANUALLY_FAILED";

